export default __webpack_public_path__ + "da18bab7239857d08e96f0c0ce1258c6.png";